import { render, staticRenderFns } from "./PmtaRelays.vue?vue&type=template&id=0f0cfa42&scoped=true"
import script from "./PmtaRelays.vue?vue&type=script&lang=js"
export * from "./PmtaRelays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0cfa42",
  null
  
)

export default component.exports